/** Bump when team dashboard walkthrough content changes; keep in sync with server `constants/teamDashboardTour.ts`. */
export const CURRENT_TEAM_DASHBOARD_TOUR_VERSION = 1;
